import { Injectable } from '@angular/core';
import { IProductType } from '@app/_shared/_models';

@Injectable({
  providedIn: 'root'
})
export class ProductTypeService {
  public productTypes: Array<IProductType> = [
    { label: 'Algaecides', tag: 'Algae Control' },
    { label: 'Balancers', tag: 'Balancers' },
    { label: 'Bromine', tag: 'Bromine' },
    { label: 'Biguanide', tag: 'Biguanide' },
    { label: 'Chlorine', tag: 'Chlorine' },
    { label: 'Cleaners', tag: 'Cleaners' },
    { label: 'Enhancers', tag: 'Enhancers' },
    { label: 'Enzymes', tag: 'Natural Enzymes' },
    { label: 'Foam Remover', tag: 'Foam Remover' },
    { label: 'Non-Chlorine', tag: 'Non-Chlorine Products' },
    { label: 'Phosphate Removers', tag: 'Phosphate Remover' },
    { label: 'Salt Water', tag: 'Salt Water' },
    { label: 'Shock', tag: 'Shock' },
    // { label: 'Soft Swim', tag: 'Soft Swim' },
    { label: 'Stain & Scale', tag: 'Stain & Scale' },
    { label: 'Water Clarifiers', tag: 'Water Clarifier' },
    { label: 'Water Testing', tag:  'Water Testing' },
    { label: 'Winterization', tag: 'Winterization' }
  ];

  constructor() { }
}
